export default __webpack_public_path__ + "static/icon-features-1-4a7a00b844c05392974c0f15cbd27cbc.png";